import { createFileRoute, redirect } from "@tanstack/react-router";
import z from "zod";

const Home = () => {
  return null;
};

export const Route = createFileRoute("/_private/(with-footer)/")({
  validateSearch: z.object({
    redirect: z.string().optional().catch(""),
  }),
  beforeLoad: async ({ search }) => {
    throw redirect({ to: search.redirect ?? "/careplan" });
  },
  component: Home,
});
